import fullPaymentOrder from "@irati/payments/services/fragments/fullPaymentOrder"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const query = gql`
  query getTopUps($status: String!, $scrollId: String, $businessId: ID) {
    getTopUps(status: $status, scrollId: $scrollId, businessId: $businessId) {
      scrollId
      fromScrollId
      total
      topUps {
        totalToPay
        uuid
        createdBy {
          firstName
          lastName
          email
          uuid
        }
        amount
        currency
        walletUuid
        walletTransferUuid
        walletType
        walletTypeUuid
        flexiPointAmount
        flexiPointCurrency
        payment {
          status
          type
          paymentOrderUuid
          invoiceUuid
          poNumber
          invoiceNumber
        }
        metadata {
          createdAt
        }
        paymentOrder {
          ...fullPaymentOrder
        }
      }
    }
  }
  ${fullPaymentOrder}
`

export const getTopUpsKey = getQueryNames(query)[0]

export default query
